import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PageShell({ children, bg = 'canvas' }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const bgClass = bg === 'canvas' ? 'bg-canvas-radial' : bg === 'white' ? 'bg-white' : 'bg-canvas-100';
  return (
    <div className={`min-h-screen ${bgClass}`}>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
